import { gql } from '@apollo/client';
import { AUTHENTICATION_SCOPES } from '@playbookux/playbook-web-core';
import client from '../../../core/services/graphql';

export const GET_PUBLIC_TEST_SESSION = gql`
  query TestSession($id: ID!) {
    testSession(id: $id) {
      id
      meetingUrlTester
      tester {
        segment {
          device
          operatingSystem
        }
      }
    }
  }
`;

export const getPublicTestSessionById = async (testSessionId) => {
  client.setScope(AUTHENTICATION_SCOPES.PUBLIC);
  client.setToken(null);

  const { data } = await client.getClient().query({
    query: GET_PUBLIC_TEST_SESSION,
    variables: { id: testSessionId },
  });

  return data.testSession;
};
